export const getSearchPath = state => state.router.location.search;
